const { default: Swiper } = require('swiper');
const { Autoplay, EffectFade } = require('swiper/modules');

const sections = document.querySelectorAll('section.blog-slider');

if (sections.length) {
    sections.forEach(section => {
        const swiperEl = section.querySelector('.swiper');
        const paginationItems = section.querySelectorAll(
            '[data-pagination-key]'
        );
        const imageItems = section.querySelectorAll('[data-image-key]');

        if (swiperEl) {
            const swiper = new Swiper(swiperEl, {
                loop: true,
                modules: [Autoplay, EffectFade],
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                autoplay: {
                    disableOnInteraction: false,
                    waitForTransition: false,
                    delay: 8000,
                },
            });

            // setInterval(() => {
            //     if (!swiper.autoplay.running) {
            //         swiper.slideNext();
            //         swiper.autoplay.start();
            //     }
            // }, 8000);

            swiper.on('slideChange', e => {
                const { realIndex } = e;
                paginationItems.forEach((bullet, index) => {
                    if (index === realIndex) {
                        bullet.classList.add('-active');
                    } else {
                        bullet.classList.remove('-active');
                    }
                });
                imageItems.forEach((image, index) => {
                    if (index === realIndex) {
                        image.classList.add('-active');
                    } else {
                        image.classList.remove('-active');
                    }
                });
            });

            paginationItems.forEach((bullet, index) => {
                bullet.addEventListener('click', () => {
                    swiper.slideToLoop(index);
                });
            });
        }
    });
}
